import { Button } from '@latitude/button';
import { Card } from '@latitude/card';
import { PortoLogoIcon } from '@latitude/icons';
import { Separator } from '@latitude/separator';
import { Text } from '@latitude/text';
import Image from 'next/image';

import {
  PORTO_ONBOARDING_SCHEDULE_URL,
  REGISTRATION_COMPLETE_CARDS,
} from '../../constants';
import RegistrationCompleteIllustration from '../../images/registration-complete.svg';
import { NextSteps } from './NextSteps';

const RegistrationCompletePage = () => {
  return (
    <div className="flex size-full flex-col overflow-y-scroll p-6 sm:px-10 lg:pt-9">
      <PortoLogoIcon className="h-11 shrink-0 self-start" />
      <div className="mx-auto my-4 flex max-w-[1120px] flex-col justify-center gap-16 sm:my-auto lg:my-20 lg:justify-normal">
        <div className="grid min-w-0 content-center gap-4 [grid-template-areas:'image''title''description'] sm:gap-8 lg:gap-x-[120px] lg:gap-y-4 lg:[grid-template-areas:'title_image''description_image']">
          <Text variant="metricHuge" className="[grid-area:title]">
            Registration complete
          </Text>
          <div className="min-w-0 [grid-area:description]">
            <Text variant="bodyRegular" className="mb-6">
              Thanks for signing up for Porto, Anchorage Digital&apos;s
              institutional grade self-custody wallet. We&apos;re pleased to
              welcome you to the platform and ask that you{' '}
              <Text
                asChild
                variant="link"
                className="text-color-ref-text-link-primary"
              >
                <a
                  href={PORTO_ONBOARDING_SCHEDULE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-color-ref-text-strong"
                >
                  schedule a call with our onboarding team
                </a>
              </Text>{' '}
              to get your account activated.
            </Text>
            <NextSteps />
          </div>
          <Image
            loading="eager"
            src={RegistrationCompleteIllustration}
            width={280}
            alt="illustration"
            className="hidden justify-self-center [grid-area:image] sm:block"
          />
        </div>
        <Separator className="hidden lg:block" />
        <div className="hidden w-full flex-col gap-5 lg:flex">
          <Text variant="headingMedium">In the meantime...</Text>
          <div className="grid grid-cols-3 gap-5">
            {REGISTRATION_COMPLETE_CARDS.map(({ title, content, url }) => (
              <Card
                key={`registration-complete-card-${title}`}
                className="min-h-[281px] px-6 py-8 text-color-ref-text-strong"
              >
                <div className="flex h-full flex-col justify-between gap-6">
                  <div className="flex flex-col gap-2">
                    <Text variant="headingSmall">{title}</Text>
                    <Text variant="bodyRegular">{content}</Text>
                  </div>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    <Button variant="neutral" type="outline" size="small">
                      Learn more
                    </Button>
                  </a>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export { RegistrationCompletePage };
